import { useMemo, useState } from "react";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { ArticleCard, ArticleRow } from "@/components/feature/NewsCard";
import { usePageMeta, JsonLd } from "@/hooks/useSeo";
import { articles, columns, columnMap, hotList, testimonials, faqs } from "@/mocks/news";
import { Link } from "react-router-dom";

type TabKey = "all" | "star" | "variety" | "crew" | "schedule";

export default function Home() {
  usePageMeta({
    title: "98爆料 - 娱乐八卦 明星动态 综艺内幕 剧组消息 艺人行程",
    description:
      "98爆料专注娱乐八卦与明星动态，聚合综艺内幕、剧组消息与艺人行程。明星真实动态、综艺录制内幕、剧组未播花絮、艺人私下行踪每日更新，点开就看最新娱乐猛料。",
  });

  const [activeTab, setActiveTab] = useState<TabKey>("all");
  const hero = articles[0];
  const heroColumn = columnMap[hero.column];
  const topArticles = [...articles].filter((a) => a.hot).sort((a, b) => (b.hot ?? 0) - (a.hot ?? 0));
  const hotListRows = [...articles]
    .sort((a, b) => Number(b.views.replace("万", "")) - Number(a.views.replace("万", "")))
    .slice(0, 6);

  const feed = useMemo(() => {
    if (activeTab === "all") return articles;
    return articles.filter((a) => a.column === activeTab);
  }, [activeTab]);

  const featured = articles.find((a) => a.id === "baoliao-2026-0904-04");

  const tabs: { key: TabKey; label: string }[] = [
    { key: "all", label: "全部瓜报" },
    ...columns.map((c) => ({ key: c.slug as TabKey, label: c.name })),
  ];

  const siteJsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebSite",
          name: "98爆料",
          url: "https://qlntroh.cn/",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://qlntroh.cn/?s={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        },
        {
          "@type": "Organization",
          name: "98爆料",
          url: "https://qlntroh.cn/",
          logo: "https://qlntroh.cn/logo.png",
          description: "专注娱乐八卦、明星动态、综艺内幕、剧组消息与艺人行程的娱乐资讯门户。",
        },
      ],
    }),
    [],
  );

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={siteJsonLd} />
      <Header />

      <main>
        {/* ===== 首屏：头条 + 实时瓜流 + 瓜榜 ===== */}
        <section className="mx-auto max-w-7xl px-4 pb-6 pt-6 md:px-6 md:pt-8">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
            {/* 左侧头条 + 实时瓜流 */}
            <div className="space-y-6 lg:col-span-8">
              {/* 头条瓜 */}
              <Link
                to={`/story/${hero.id}`}
                className="group grid grid-cols-1 overflow-hidden rounded-2xl border border-background-200 bg-background-100 transition-colors hover:border-secondary-300 md:grid-cols-12"
              >
                <div className="relative aspect-[16/10] w-full overflow-hidden md:col-span-7 md:aspect-auto md:min-h-[320px]">
                  <img
                    src={hero.image}
                    alt={`${hero.title} - ${heroColumn.name}`}
                    title={`${hero.title} ${heroColumn.name}`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                    <i className="ri-flashlight-fill"></i>
                    今日头条瓜
                  </span>
                </div>
                <div className="flex flex-col justify-center p-5 md:col-span-5 md:p-6">
                  <span
                    className="inline-flex w-fit items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-bold text-background-50"
                    style={{ backgroundColor: heroColumn.accent }}
                  >
                    <i className={heroColumn.icon}></i>
                    {heroColumn.name}
                  </span>
                  <h1 className="mt-3 font-heading text-xl font-black leading-snug text-foreground-950 group-hover:text-primary-600 md:text-2xl">
                    {hero.title}
                  </h1>
                  <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600">
                    {hero.excerpt}
                  </p>
                  <div className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {hero.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {hero.views}
                    </span>
                  </div>
                  <span className="mt-4 inline-flex w-fit items-center gap-1 text-sm font-bold text-primary-600">
                    点开吃瓜
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                  </span>
                </div>
              </Link>

              {/* 热搜词条 */}
              <div className="flex flex-wrap items-center gap-2 rounded-2xl border border-background-200 bg-background-100 px-4 py-3">
                <span className="flex items-center gap-1 whitespace-nowrap text-sm font-bold text-primary-600">
                  <i className="ri-fire-fill"></i>
                  实时热搜
                </span>
                {hotList.map((h) => (
                  <span
                    key={h}
                    className="cursor-pointer whitespace-nowrap rounded-full bg-background-200 px-3 py-1 text-xs text-foreground-600 transition-colors hover:bg-primary-100 hover:text-primary-700"
                  >
                    {h}
                  </span>
                ))}
              </div>

              {/* 实时瓜报流 */}
              <div>
                <div className="flex flex-wrap items-center gap-2 rounded-full border border-background-200 bg-background-100 p-1">
                  {tabs.map((t) => (
                    <button
                      key={t.key}
                      type="button"
                      onClick={() => setActiveTab(t.key)}
                      className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                        activeTab === t.key
                          ? "bg-primary-500 text-background-50"
                          : "text-foreground-600 hover:bg-secondary-100"
                      }`}
                    >
                      {t.label}
                    </button>
                  ))}
                </div>

                <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2">
                  {feed.slice(0, 4).map((a) => (
                    <ArticleCard key={a.id} article={a} column={columnMap[a.column]} />
                  ))}
                </div>
                <Link
                  to={`/column/${activeTab === "all" ? "star" : activeTab}`}
                  className="mt-5 flex w-full items-center justify-center gap-1.5 rounded-xl border border-background-300 bg-background-100 py-2.5 text-sm font-medium text-foreground-600 transition-colors hover:border-secondary-300 hover:text-primary-600"
                >
                  查看更多今日瓜报
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>

            {/* 右侧今日瓜榜 */}
            <aside className="lg:col-span-4" aria-label="今日瓜榜">
              <div className="rounded-2xl border border-background-200 bg-background-100 p-5">
                <div className="flex items-center justify-between">
                  <h2 className="flex items-center gap-2 font-heading text-lg font-black text-foreground-950">
                    <i className="ri-trophy-line text-secondary-500"></i>
                    今日瓜榜
                  </h2>
                  <span className="text-xs text-foreground-400">24小时热榜</span>
                </div>
                <div className="mt-4 flex flex-col">
                  {hotListRows.map((a, idx) => (
                    <ArticleRow key={a.id} article={a} column={columnMap[a.column]} />
                  ))}
                </div>
                <div className="mt-4 border-t border-background-200 pt-4">
                  <h3 className="text-xs font-bold text-foreground-500">吃瓜小贴士</h3>
                  <p className="mt-2 rounded-xl bg-secondary-100 p-3 text-xs leading-relaxed text-secondary-800">
                    <i className="ri-lightbulb-flash-line mr-1 text-secondary-600"></i>
                    瓜料虽好，理性为先。本站坚持事实与解读分开标注，网传内容仅作参考，不信谣不传谣。
                  </p>
                </div>
              </div>
            </aside>
          </div>
        </section>

        {/* ===== 专题 banner ===== */}
        {featured && (
          <section className="px-4 md:px-6">
            <Link
              to={`/story/${featured.id}`}
              className="group relative mx-auto block max-w-7xl overflow-hidden rounded-2xl"
            >
              <img
                src={featured.image}
                alt={`${featured.title} - 专题深度`}
                title={`${featured.title} 专题深度`}
                className="h-[340px] w-full object-cover object-top transition-transform duration-700 group-hover:scale-105 md:h-[360px]"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/50 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-center p-6 md:p-12">
                <span className="flex w-fit items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-accent-950">
                  <i className="ri-douban-line"></i>
                  全网热议
                </span>
                <h2 className="mt-4 max-w-xl font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
                  {featured.title}
                </h2>
                <p className="mt-3 max-w-lg line-clamp-2 text-sm text-background-200 md:text-base">
                  {featured.excerpt}
                </p>
                <span className="mt-5 inline-flex w-fit items-center gap-1.5 rounded-full bg-background-50 px-4 py-2 text-sm font-bold text-foreground-950 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  深入吃瓜
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          </section>
        )}

        {/* ===== 栏目矩阵 ===== */}
        <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
          <div className="flex items-end justify-between">
            <div>
              <span className="text-xs font-bold tracking-[0.2em] text-primary-600">COLUMNS</span>
              <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                分类吃瓜，各有各的精彩
              </h2>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {columns.map((c) => {
              const list = articles.filter((a) => a.column === c.slug).slice(0, 3);
              return (
                <Link
                  key={c.slug}
                  to={`/column/${c.slug}`}
                  className="group flex flex-col rounded-2xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-secondary-300"
                >
                  <div className="flex items-center gap-3">
                    <span
                      className="flex h-11 w-11 items-center justify-center rounded-xl text-xl text-background-50"
                      style={{ backgroundColor: c.accent }}
                    >
                      <i className={c.icon}></i>
                    </span>
                    <div>
                      <h3 className="font-heading text-base font-black text-foreground-950">
                        {c.name}
                      </h3>
                      <span className="text-xs text-foreground-400">{list.length} 篇今日更新</span>
                    </div>
                  </div>
                  <p className="mt-3 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                    {c.desc}
                  </p>
                  <div className="mt-4 flex flex-col divide-y divide-background-200 border-y border-background-200">
                    {list.map((a) => (
                      <span
                        key={a.id}
                        className="line-clamp-1 py-2 text-sm text-foreground-700 transition-colors group-hover:text-primary-600"
                      >
                        <i className="ri-corner-down-right-fill mr-1 text-xs text-secondary-400"></i>
                        {a.title}
                      </span>
                    ))}
                  </div>
                  <span className="mt-4 flex items-center gap-1 text-sm font-bold text-primary-600">
                    进入栏目
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                  </span>
                </Link>
              );
            })}
          </div>
        </section>

        {/* ===== 深度长瓜精选 ===== */}
        <section className="bg-secondary-100/70">
          <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
            <div className="flex items-end justify-between gap-4">
              <div>
                <span className="text-xs font-bold tracking-[0.2em] text-secondary-700">
                  IN-DEPTH
                </span>
                <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                  不止吃瓜，更懂来龙去脉
                </h2>
              </div>
            </div>
            <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
              {articles.slice(4, 7).map((a) => (
                <ArticleCard key={a.id} article={a} column={columnMap[a.column]} compact />
              ))}
            </div>
          </div>
        </section>

        {/* ===== 读者口碑 ===== */}
        <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
          <div className="text-center">
            <span className="text-xs font-bold tracking-[0.2em] text-accent-600">REVIEWS</span>
            <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              吃瓜群众怎么说
            </h2>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="flex flex-col rounded-2xl border border-background-200 bg-background-100 p-6"
              >
                <div className="flex items-center gap-1 text-accent-500">
                  <i className="ri-star-s-fill"></i>
                  <i className="ri-star-s-fill"></i>
                  <i className="ri-star-s-fill"></i>
                  <i className="ri-star-s-fill"></i>
                  <i className="ri-star-s-fill"></i>
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-black text-primary-700">
                    {t.name.slice(1, 3)}
                  </span>
                  <div>
                    <div className="text-sm font-bold text-foreground-950">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        {/* ===== FAQ ===== */}
        <section className="mx-auto max-w-7xl px-4 pb-14 md:px-6">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
            <div className="lg:col-span-5">
              <span className="text-xs font-bold tracking-[0.2em] text-primary-600">FAQ</span>
              <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                关于吃瓜，你可能想问
              </h2>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
                关于98爆料的瓜源、更新速度与内容核实原则，这里集中为你解答。仍有疑问欢迎联系小编。
              </p>
              <Link
                to="/about"
                className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-file-user-line"></i>
                了解我们
              </Link>
            </div>
            <div className="space-y-3 lg:col-span-7">
              {faqs.slice(0, 4).map((f, i) => (
                <div
                  key={i}
                  className="rounded-2xl border border-background-200 bg-background-100 p-5"
                >
                  <h3 className="flex items-start gap-2 text-sm font-bold text-foreground-950 md:text-base">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-accent-100 text-xs font-black text-accent-700">
                      Q
                    </span>
                    {f.q}
                  </h3>
                  <p className="mt-2 pl-8 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}